angular.module('ihestiaRestServicesBase')
.factory('ihestiaModelHelper', ['lsnModelHelper', function(lsnModelHelper){
  return lsnModelHelper;
}]);